import {
  aiChatResponseSchema,
  aiStatusSchema,
  PORTAL_CHAT_DRAFT_STORAGE_KEY,
  type AiChatMessage,
  type AiChatResponse,
  type AiChatTicketDraft,
} from '@gb-ticket/shared-types';
import { useMutation, useQuery } from '@tanstack/react-query';

import { apiFetch } from '@/lib/api';

export const aiStatusQueryKey = ['ai', 'status'] as const;

export function useAiStatus() {
  return useQuery({
    queryKey: aiStatusQueryKey,
    queryFn: () => apiFetch('/ai/status', aiStatusSchema),
    staleTime: 30_000,
  });
}

export function useAiChat() {
  return useMutation({
    mutationFn: (messages: AiChatMessage[]) =>
      apiFetch('/ai/chat', aiChatResponseSchema, {
        method: 'POST',
        body: JSON.stringify({ messages }),
      }),
  });
}

export function storeChatTicketDraft(draft: AiChatTicketDraft): void {
  sessionStorage.setItem(PORTAL_CHAT_DRAFT_STORAGE_KEY, JSON.stringify(draft));
}

export function readChatTicketDraft(): AiChatTicketDraft | null {
  const raw = sessionStorage.getItem(PORTAL_CHAT_DRAFT_STORAGE_KEY);
  if (!raw) {
    return null;
  }
  try {
    const parsed = JSON.parse(raw) as AiChatTicketDraft;
    if (typeof parsed.subject === 'string' && typeof parsed.description === 'string') {
      return parsed;
    }
  } catch {
    return null;
  }
  return null;
}

export function clearChatTicketDraft(): void {
  sessionStorage.removeItem(PORTAL_CHAT_DRAFT_STORAGE_KEY);
}

export type { AiChatResponse };
